import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ScholarShipsTable from "components/CRPComponents/Tables/ScholarShipsTable";
import { Permissions } from "./permissions";

function ScholarShipsListPage(): JSX.Element {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ScholarShipsTable
        path="/uniftec"
        actionsPermission={{
          createPermision: Permissions.create,
          deletePermision: Permissions.delete,
          updatePermision: Permissions.update,
        }}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ScholarShipsListPage;
